/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Title, Text } from 'components/Text';
import { CardWrapper, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Sobre o pagamento
      </Title>
      <Text>
        A <strong>petição inicial</strong> contém o seu nome, documentos, endereço e ainda demonstra seu direito, com fundamentos jurídicos simples e diretos.
      </Text>
      <Text>
        A <strong>planilha de cálculo</strong> permite que você apresente para o Juiz uma estimativa do quanto seu FGTS perdeu valor de compra com o passar dos anos.
      </Text>
      <Text>
        Esse conjunto permitirá que você entre sozinho com o processo na Justiça.
      </Text>
      <Text>
        Realizando a compra do KIT com o <strong>serviço de atermação</strong>, a nossa equipe fará o protocolo necessário para dar a entrada da sua ação de Revisão do FGTS no Juizado Especial Federal da sua região.
        O serviço é feito totalmente remoto e o nosso compromisso vai até o momento em que o processo é aceito pelo JEF.
        Atenção: não realizamos o acompanhamento do processo ou prestamos qualquer tipo de assessoria jurídica, serviços estes restritos à atuação de advogados.
      </Text>
      <BoxButton>
        <a
          onClick={() => {
            window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
            window.Intercom('show');
            onClose(false);
          }}
        >
          Ainda está com dúvidas? Clique aqui para acessar a central de ajuda
        </a>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
